(function () {
  var root = document.getElementById('rs-spot');
  if (!root || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');
  document.body.appendChild(root);

  var dlg = root.querySelector('.rs-dialog');
  var form = root.querySelector('.rs-bar');
  var input = root.querySelector('.rs-input');
  var clearBtn = root.querySelector('.rs-clear');
  var empty = root.querySelector('.rs-empty');
  var results = root.querySelector('.rs-results');
  var sugs = root.querySelector('.rs-sugs');
  var grid = root.querySelector('.rs-grid');
  var none = root.querySelector('.rs-none');
  var foot = root.querySelector('.rs-foot');
  var allLink = root.querySelector('.rs-all');
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var mq = window.matchMedia('(max-width: 767px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var lastFocus = null, timer = null, ctrl = null, active = -1, closeTimer = null, anim = null;
  var T = {
    none: root.getAttribute('data-t-none') || '“{q}” için sonuç bulunamadı.',
    all: root.getAttribute('data-t-all') || '“{q}” için tüm sonuçlar →'
  };

  function fmt(v) { return Math.round(v).toLocaleString('tr-TR') + ' TL'; }
  Array.prototype.forEach.call(root.querySelectorAll('[data-cents]'), function (el) {
    el.textContent = fmt(Number(el.getAttribute('data-cents')) / 100);
  });
  function searchUrl(q) { return base + 'search?type=product&q=' + encodeURIComponent(q); }

  // Boyut degisimlerini yumusak gecisle canlandirir (FLIP).
  function morph(change) {
    if (mq.matches || reduce.matches || !dlg.animate || root.hidden) { change(); return; }
    var a = dlg.getBoundingClientRect();
    if (anim) { anim.cancel(); anim = null; }
    change();
    var b = dlg.getBoundingClientRect();
    if (Math.abs(a.height - b.height) < 1 && Math.abs(a.width - b.width) < 1 && Math.abs(a.top - b.top) < 1) return;
    dlg.style.overflow = 'hidden';
    anim = dlg.animate([
      { top: a.top + 'px', width: a.width + 'px', height: a.height + 'px' },
      { top: b.top + 'px', width: b.width + 'px', height: b.height + 'px' }
    ], { duration: 420, easing: 'cubic-bezier(.22,.8,.24,1)' });
    var done = function () { dlg.style.overflow = ''; anim = null; };
    anim.onfinish = done;
    anim.oncancel = done;
  }

  function open() {
    if (!root.hidden) return;
    clearTimeout(closeTimer);
    lastFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('rs-lock');
    // Odak dokunusla ayni anda verilir; iPhone'da klavye boylece hemen acilir.
    try { input.focus({ preventScroll: true }); } catch (e) {}
    requestAnimationFrame(function () { root.classList.add('is-open'); if (document.activeElement !== input) input.focus(); });
  }
  function close() {
    if (root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('rs-lock');
    closeTimer = setTimeout(function () { root.hidden = true; root.setAttribute('aria-hidden', 'true'); }, 250);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  window.RunicSpotlight = { open: open, close: close };

  var TRIGGER = '[data-drawer-options*="t4s-search-hidden"],[data-rs-open]';
  window.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest(TRIGGER);
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  // iPhone Safari bazen ilk dokunusu "hover" sayip click gondermiyor (iki kez dokunmak gerekiyordu).
  // Bu yuzden dokunmatik ekranda arama, parmak kalktigi anda acilir.
  var tx = 0, ty = 0, tOn = false;
  window.addEventListener('touchstart', function (e) {
    var t = e.target && e.target.closest && e.target.closest(TRIGGER);
    tOn = !!t;
    if (t && e.touches && e.touches[0]) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; }
  }, { capture: true, passive: true });
  window.addEventListener('touchend', function (e) {
    if (!tOn) return;
    tOn = false;
    var t = e.target && e.target.closest && e.target.closest(TRIGGER);
    var p = e.changedTouches && e.changedTouches[0];
    if (!t || !p || Math.abs(p.clientX - tx) > 10 || Math.abs(p.clientY - ty) > 10) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, { capture: true, passive: false });

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-rs-close]')) { e.preventDefault(); close(); }
  });

  function reset() {
    if (ctrl) ctrl.abort();
    active = -1;
    if (!dlg.classList.contains('rs-has-q')) return;
    morph(function () {
      dlg.classList.remove('rs-has-q');
      empty.hidden = false;
      results.hidden = true;
      foot.hidden = true;
    });
  }

  function boldPrefix(el, text, q) {
    var i = text.toLowerCase().indexOf(q.toLowerCase());
    if (i < 0) { el.appendChild(document.createTextNode(text)); return; }
    if (i > 0) el.appendChild(document.createTextNode(text.slice(0, i)));
    var b = document.createElement('b'); b.textContent = text.slice(i, i + q.length); el.appendChild(b);
    el.appendChild(document.createTextNode(text.slice(i + q.length)));
  }

  function imgUrl(p) {
    var u = p.image || (p.featured_image && p.featured_image.url) || '';
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=480';
  }

  function fill(q, data) {
    var queries = (data.queries || []).filter(function (s) { return s.text && s.text.toLowerCase() !== q.toLowerCase(); }).slice(0, 3);
    var products = data.products || [];
    active = -1;

    sugs.innerHTML = '';
    queries.forEach(function (s) {
      var a = document.createElement('a');
      a.className = 'rs-sug';
      a.href = searchUrl(s.text);
      a.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#6E6A64" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="M20 20l-4-4"></path></svg>';
      var span = document.createElement('span');
      boldPrefix(span, s.text, q);
      a.appendChild(span);
      sugs.appendChild(a);
    });

    grid.innerHTML = '';
    products.forEach(function (p) {
      var a = document.createElement('a');
      a.className = 'rs-item';
      a.href = p.url;
      var im = document.createElement('span'); im.className = 'rs-img';
      var src = imgUrl(p);
      if (src) { var img = document.createElement('img'); img.src = src; img.alt = p.title; img.decoding = 'async'; im.appendChild(img); }
      var meta = document.createElement('span'); meta.className = 'rs-meta';
      var n = document.createElement('span'); n.className = 'rs-name'; n.textContent = p.title;
      var pr = document.createElement('span'); pr.className = 'rs-price'; pr.textContent = fmt(Number(p.price));
      meta.appendChild(n); meta.appendChild(pr);
      a.appendChild(im); a.appendChild(meta);
      grid.appendChild(a);
    });

    none.hidden = products.length > 0;
    none.textContent = T.none.replace('{q}', q);
    allLink.href = searchUrl(q);
    allLink.textContent = T.all.replace('{q}', q);
  }

  function render(q, data) {
    morph(function () {
      dlg.classList.add('rs-has-q');
      empty.hidden = true;
      results.hidden = false;
      foot.hidden = false;
      fill(q, data);
    });
  }

  function search(q) {
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    var url = base + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,query&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last';
    fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (input.value.trim() !== q) return;
        render(q, (d.resources && d.resources.results) || {});
      })
      .catch(function () {});
  }

  input.addEventListener('input', function (e) {
    e.stopPropagation();
    var q = input.value.trim();
    clearBtn.hidden = !q;
    clearTimeout(timer);
    if (!q) { reset(); return; }
    timer = setTimeout(function () { search(q); }, 160);
  });
  ['keyup', 'focus', 'focusin', 'change'].forEach(function (ev) {
    input.addEventListener(ev, function (e) { e.stopPropagation(); });
  });

  clearBtn.addEventListener('click', function () {
    input.value = '';
    clearBtn.hidden = true;
    reset();
    input.focus();
  });

  function setActive(i) {
    var items = grid.querySelectorAll('.rs-item');
    if (!items.length) return;
    if (i < 0) i = -1;
    if (i > items.length - 1) i = items.length - 1;
    active = i;
    Array.prototype.forEach.call(items, function (el, k) { el.classList.toggle('is-active', k === active); });
    if (active > -1 && items[active].scrollIntoView) items[active].scrollIntoView({ block: 'nearest' });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var items = grid.querySelectorAll('.rs-item');
    if (active > -1 && items[active]) { window.location.href = items[active].href; return; }
    var q = input.value.trim();
    if (q) window.location.href = searchUrl(q);
  });

  document.addEventListener('keydown', function (e) {
    var k = e.key;
    if ((e.metaKey || e.ctrlKey) && k && k.toLowerCase() === 'k') {
      e.preventDefault();
      if (root.hidden) open(); else close();
      return;
    }
    if (root.hidden) return;
    if (k === 'Escape') { e.preventDefault(); close(); return; }
    if (results.hidden) return;
    var cols = mq.matches ? 1 : 3;
    if (k === 'ArrowDown') { e.preventDefault(); setActive(active < 0 ? 0 : active + cols); }
    else if (k === 'ArrowUp') { if (active > -1) { e.preventDefault(); setActive(active - cols < 0 ? -1 : active - cols); } }
    else if (k === 'ArrowRight' && active > -1) { e.preventDefault(); setActive(active + 1); }
    else if (k === 'ArrowLeft' && active > -1) { e.preventDefault(); setActive(active - 1); }
  });
})();
